export const DEFAULT_LOCALE = "en-US" as const;

export const SUPPORTED_LOCALES = {
  enUs: DEFAULT_LOCALE,
  es419: "es-419",
} as const;

export const DEFAULT_TRANSLATION_SETTINGS = {
  enabled: false,
  fallbackLocale: DEFAULT_LOCALE,
  locale: DEFAULT_LOCALE,
  version: 1,
} as const;

export const TRANSLATION_SETTINGS_STORAGE_KEY = "CBH_ADMIN_TRANSLATION_SETTINGS_V1";

export const INTERPOLATION_PATTERN = /\{\{(\w+)\}\}/g;

export const I18N_NAMESPACES = {
  chat: "chat",
  common: "common",
  navigation: "navigation",
  schedule: "schedule",
  settings: "settings",
} as const;
